import React, { memo } from 'react';

import { SpinnerOverlay, SubmissionButtons } from '@components/common';

import { getConfirmModalText } from './utils';

import styles from './ConfirmActionModal.module.scss';

interface IConfirmActionModal {
	closeModal: () => void;
	confirmAction: () => void;
	notPossibleToAddCount: number;
	totalAssets: number;
	isSending: boolean;
}

const ConfirmActionModal = ({
	closeModal,
	confirmAction,
	notPossibleToAddCount,
	totalAssets,
	isSending,
}: IConfirmActionModal) => {
	const areAllAssetsNotIncluded = notPossibleToAddCount > 1 && totalAssets === notPossibleToAddCount;

	return (
		<>
			{isSending && <SpinnerOverlay />}
			<div className={styles.confirmActionModal}>
				<div className={styles.infoText}>
					{getConfirmModalText(notPossibleToAddCount, totalAssets)}
				</div>
				<div className={styles.questionText}>
					{areAllAssetsNotIncluded
						? 'Select other Assets on the map.'
						: 'Do you agree to proceed with available assets?'
					}
				</div>
				<SubmissionButtons
					isNegativeButtonNeeded={!areAllAssetsNotIncluded}
					negativeHandler={closeModal}
					positiveHandler={areAllAssetsNotIncluded ? closeModal : confirmAction}
					positiveLabel={areAllAssetsNotIncluded ? 'Ok' : 'Yes'}
				/>
			</div>
		</>
	);
};

export default memo(ConfirmActionModal);
